//
//
//
//
//
//
//
//
//

export default {
    props: {
        options: {
            type: Object,
            required: true,
        },
        value: {
            type: [ Number, String ],
            required: true,
        }
    },
    data() {
        return {

        };
    },
    watch: {
        value: function(value) {
            const button = this.$el.querySelector('[data-value="' + value + '"]')

            const posX = button.getBoundingClientRect().left - this.$el.getBoundingClientRect().left;

            this.$refs.span.style.left = posX + 'px';
            this.$refs.span.style.width = button.getBoundingClientRect().width + 'px';
        }
    },
    methods: {
        handleClick($event, new_value)
        {
            const button = $event.target;

            const posX = button.getBoundingClientRect().left - this.$el.getBoundingClientRect().left;

            this.$refs.span.style.left = posX + 'px';
            this.$refs.span.style.width = button.getBoundingClientRect().width + 'px';

            this.$emit('input', new_value );
        },

        display()
        {
            if ( this.$refs.span.style.width === '' || this.$refs.span.style.width === '0px' ) {
                const value = this.value;
                const button = this.$el.querySelector('[data-value="' + value + '"]')
                const posX = button.getBoundingClientRect().left - this.$el.getBoundingClientRect().left;

                this.$refs.span.style.width = button.getBoundingClientRect().width + 'px';
                this.$refs.span.style.left = posX + 'px';
            }
        }
    },
    mounted() {
        this.display();
    }
}
